import apiClient from "./client";
import { APIUrlStrings } from "./endpoints";

export const sendEnquirywebsiteDemo = (payload) => {
  return apiClient.post(APIUrlStrings.sendEnquirywebsiteDemo, payload);
};
export const sendRequestToDeletePharamcy = (payload) => {
  return apiClient.post(APIUrlStrings.sendRequestToDeletePharamcy, payload);
};
